import React, { useState } from "react";
import { withRouter, Link } from 'react-router';
import { regionalOneInstance, jetStreamInstance, testLessor, hanwahaInstance } from "../../../../shared/components";
const ConfigData = ({ assetInfoData, location }) => {
    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 77px' }}>
            <div className='tech-specs-nav'>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/manufacturers') ? 'active' : ''} to={`/config-data/manufacturers`}>Manufacturers</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link to='/config-data/aircraftFamily' className={location.pathname?.includes('config-data/aircraftFamily') ? 'active' : ''}>Aircraft Family</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/aircraftTypes') ? 'active' : ''} to={`/config-data/aircraftTypes`}>Aircraft Types</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/aircraftModels') ? 'active' : ''} to={`/config-data/aircraftModels`}>Aircraft Models</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/engineFamily') ? 'active' : ''} to={`/config-data/engineFamily`}>Engine Family</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/engineTypes') || location.pathname?.includes('config-data/engineType') ? 'active' : ''} to={`/config-data/engineTypes`}>Engine Types</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/apuTypes') ? 'active' : ''} to={`/config-data/apuTypes`}>APU Types</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/lgSubAssemblies') ? 'active' : ''} to={`/config-data/lgSubAssemblies`}>LG Sub-Assemblies</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/region') ? 'active' : ''} to={`/config-data/region`}>Region</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/engineLlpsConfig') ? 'active' : ''} to={`/config-data/engineLlpsConfig`}>Engine LLP Config</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/maintenancePrograms') ? 'active' : ''} to={`/config-data/maintenancePrograms`}>Maintenance Program</Link>
                </div>
                {regionalOneInstance || testLessor ?
                    <div className='tech-nav-link'>
                        <Link className={location.pathname?.includes('config-data/stc-mods') ? 'active' : ''} to={`/config-data/stc-mods`}> STCs & Mods</Link>
                    </div>
                    : null}
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/distribution') ? 'active' : ''} to={`/config-data/distribution`}>Distribution Email(s)</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/owner-lessor') ? 'active' : ''} to={`/config-data/owner-lessor`}>{jetStreamInstance ? "Owner/SPV" : "Owner"} & {jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/banking-details') ? 'active' : ''} to={`/config-data/banking-details`}>Banking Details</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/lessee-config') ? 'active' : ''} to={`/config-data/lessee-config`}>Lessee Config</Link>
                </div>
                <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/contact-list') ? 'active' : ''} to={`/config-data/contact-list`}>Contact List</Link>
                </div>
                {hanwahaInstance?
                    <div className='tech-nav-link'>
                    <Link className={location.pathname?.includes('config-data/inventory-list') ? 'active' : ''} to={`/config-data/inventory-list`}>Inventory Type</Link>
                </div>
                :null}
            </div>
        </section>
    )
}
export default withRouter(ConfigData);